$(document).ready(function () {
  $(".table-scroll .table-wrap").scroll(function () {
    var scrollLeft = $(".table-scroll .table-wrap").scrollLeft();
    $(".table-scroll .table-top-scroll")[0].scrollLeft = scrollLeft;
  });
  $(".table-scroll .table-top-scroll").scroll(function () {
    var scrollLeft = $(".table-scroll .table-top-scroll").scrollLeft();
    $(".table-scroll .table-wrap")[0].scrollLeft = scrollLeft;
  });
})